/**
 * @file 遮罩层组件
 * @param visible: boolean 是否展示遮罩层
 * @param children: ReactElement 插槽内容
 * @param style:CSSProperties 样式, 用于覆写、扩展遮罩层的样式
 */

import type { ReactElement } from 'react';
import React, { useCallback } from 'react';

interface Props {
  visible: boolean;
  children: ReactElement;
  style?: React.CSSProperties
  onClick?: () => void
}

const defaultStyles: React.CSSProperties = {
  'position': 'fixed',
  'top': 0,
  'left': 0,
  'height': '100vh',
  'width': '100vw',
  'background': 'rgba(0, 0, 0, 0.35)',
  'zIndex': 1000,
  'opacity': 1
}

const Mask: React.FC<Props> = ({ visible = true, children, style = {}, onClick}) => {


  if(!visible) {
    return null
  }

  const handleClick = useCallback(() => {
    if(onClick) {
      onClick()
    }
  }, [onClick])

  return <div style={{
      ...defaultStyles,
      ...style
  }}
  onClick={handleClick}
  >
      {children}
</div>;
};
export default Mask;
